/**
 * Busca por nome sem se importar com acento ou maiúscula
 * ("marina" encontra "Dra. Marína Andrade").
 */
export function normalizeSearchText(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}

export function matchesSearch(label, query) {
  const needle = normalizeSearchText(query);
  if (!needle) return true;
  return normalizeSearchText(label).includes(needle);
}
